import { h } from "preact";
import { useEffect } from "preact/hooks";

import styles from "./VerticalResizer.module.css";

function VariantsPanelResizer({ onResize }: { onResize: (y: number) => void; }) {
    function handleResizerMouseDown(ev: MouseEvent) {
        if (ev.button !== Zeplin.MOUSE_BUTTON.LEFT) {
            return;
        }

        ev.preventDefault();

        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
    }

    function handleMouseMove(ev: MouseEvent) {
        ev.preventDefault();
        onResize(ev.clientY);
    }

    function handleMouseUp() {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    }

    useEffect(() => () => {
        document.removeEventListener("mousemove", handleMouseMove);
        document.removeEventListener("mouseup", handleMouseUp);
    }, []);

    return (
        <div class={styles.verticalResizer} onMouseDown={handleResizerMouseDown}>
            <div class={styles.resizeBar}/>
        </div>
    );
}

export default VariantsPanelResizer;
